import React, { useEffect } from 'react'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import grid_icon from '../../assets/static/images/group.png'
import { reorderColumns } from '../../utils/orderingPreferencesUtils'

function ColumnOrderDropdown({
  id,
  toggleId,
  show,
  onClose,
  columns,
  onColumnsChange,
  onReset,
  resetLabel = 'Reset Columns',
  getLabel,
  saving,
  className = 'bg-white quickActionDropdown shadow border',
  itemClassName = 'bg-white text-dark dropdown-item p-4 border-bottom',
}) {
  useEffect(() => {
    if (!show) return undefined

    const handleClickOutside = (e) => {
      const dropdown = document.getElementById(id)
      const toggle = toggleId && document.getElementById(toggleId)
      if (dropdown && !dropdown.contains(e.target) && (!toggle || !toggle.contains(e.target))) {
        onClose()
      }
    }

    document.addEventListener('click', handleClickOutside)
    return () => document.removeEventListener('click', handleClickOutside)
  }, [show, onClose, id, toggleId])

  if (!show) return null

  const onDragEnd = (result) => {
    if (!result.destination) return
    onColumnsChange(reorderColumns(columns, result.source.index, result.destination.index))
  }

  return (
    <div id={id} className={`${className} ${show ? '' : 'd-none'}`}>
      <div className="column-order-dropdown__list">
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={`${id}-list`}>
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {columns.map((column, index) => (
                  <Draggable key={column.key} draggableId={column.key} index={index}>
                    {(draggableProvided) => (
                      <div
                        ref={draggableProvided.innerRef}
                        {...draggableProvided.dragHandleProps}
                        {...draggableProvided.draggableProps}
                        style={{ ...draggableProvided.draggableProps.style }}
                        className={`${itemClassName} ${saving ? 'disabled' : ''}`}
                      >
                        <div className="d-flex justify-content-between">
                          <div className="custom-control custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id={`${id}-${column.key}`}
                              checked={!!column.visible}
                              onChange={(e) => onColumnsChange(
                                columns.map((item) => (
                                  item.key === column.key ? { ...item, visible: e.target.checked } : item
                                ))
                              )}
                            />
                            <label className="custom-control-label" htmlFor={`${id}-${column.key}`}>
                              {getLabel(column)}
                            </label>
                          </div>
                          <img src={grid_icon} alt="drag" />
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>
      {onReset &&
        <div className="column-order-dropdown__footer p-3 border-top">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm w-100"
            disabled={saving}
            onClick={onReset}
          >
            {resetLabel}
          </button>
        </div>
      }
    </div>
  )
}

export default ColumnOrderDropdown
